// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__lyIcd","body":"page_body__4Iksq","logo":"page_logo__WhQBF"};